import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Gentle fade/slide-up on scroll into view. Respects reduced motion via CSS + viewport once.
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px 0px -80px 0px" });
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const Eyebrow = ({ children, tone = "cyan", className = "" }) => {
  const color = tone === "cyan" ? "text-[#3E7B5E]" : tone === "onDark" ? "text-[#5ECCA0]" : "text-[#4C7C68]";
  return (
    <span className={`eyebrow inline-flex items-center gap-2 ${color} ${className}`}>
      <span className="inline-block w-6 h-px bg-current opacity-60" aria-hidden />
      {children}
    </span>
  );
};

export const PlaceholderBox = ({ label, ratio = "aspect-[4/5]", onDark = false, className = "" }) => (
  <div className={`ph-box ${onDark ? "on-dark" : ""} ${ratio} rounded-xl p-6 ${className}`}>
    <div className="font-mono-ui text-xs leading-relaxed max-w-[16rem]">
      <span className="block mb-2 text-base opacity-90">◇</span>
      {label}
    </div>
  </div>
);
